export class Appconfig {
 static getAPIURI() {
    return process.env.REACT_APP_BACKEND_URL;
  }
  static getEnv() {
    return process.env.NODE_ENV;
  }
}
